import { autoinject, bindable } from 'aurelia-framework';
import { NodeModel } from "../../models/node-model";

@autoinject
export class StructurePreview {
	@bindable structureData: NodeModel[];
}
